import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/sit-a/bd-mobile-next/app/components/category/CategoryContent.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/styles/category/index.module.scss");
